var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting_balloon setting_balloon_category_add" },
    [
      _c("div", { staticClass: "setting_balloon_content" }, [
        _c("div", { staticClass: "setting_balloon_content_main" }, [
          _c("div", { staticClass: "setting_balloon_rows" }, [
            _c("div", { staticClass: "setting_balloon_rows_label" }, [
              _c("p", { staticClass: "setting_balloon_rows_label_name" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.labelsProperties.categoryNameInputTitle) +
                    "\n          "
                )
              ]),
              _c("p", { staticClass: "setting_label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.labelsProperties.requireLabel) +
                    "\n          "
                )
              ])
            ]),
            _c("div", { staticClass: "setting_balloon_rows_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.category.categoryName,
                    expression: "category.categoryName"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.labelsProperties.categoryPlaceHolder
                },
                domProps: { value: _vm.category.categoryName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.category, "categoryName", $event.target.value)
                  }
                }
              })
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "setting_balloon_footer" }, [
        _c(
          "button",
          {
            staticClass: "setting_btn_outline setting_btn_small",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.labelsProperties.closeModal) + "\n    "
            )
          ]
        ),
        _c(
          "button",
          {
            staticClass: "setting_btn_primary setting_btn_small",
            class: _vm.category.categoryName ? "" : "setting_btn_disabled",
            on: {
              click: function($event) {
                return _vm.$emit("submit")
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.labelsProperties.saveCategoryButton) +
                "\n    "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }